"use strict";
// @ts-ignore
try {
    self['workbox:core:6.2.4'] && _();
}
catch (e) { }
